<!-- =======================
     FORM VIEW
======================= -->
<div *ngIf="!isSubmiited" class="form-wrapper">
  <form [formGroup]="assessmentForm" (ngSubmit)="onSubmit($event)" class="assessment-form" novalidate>

    <!-- Section Header -->
    <h3 class="section-title">Assessment & Attachments</h3>
    <p class="section-subtext">
      Provide assessment, attach evidence files and flag signals if detected.
    </p>

    <!-- Assessment Notes -->
    <div class="form-group">
      <label class="form-label">Assessment <span class="required">*</span></label>
      <mat-form-field appearance="outline" class="full-width no-label">
        <textarea
          matInput
          placeholder="Enter your assessment findings..."
          rows="5"
          formControlName="assessmentNotes"
        ></textarea>
        <mat-error *ngIf="assessmentForm.get('assessmentNotes')?.touched && assessmentForm.get('assessmentNotes')?.hasError('required')">
          Assessment is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Signal Toggle -->
    <div class="form-group">
      <label class="form-label">Is Signal Detected?</label>
      <div class="toggle-row">
        <span class="toggle-status">
          {{ assessmentForm.get('signalDetected')?.value ? 'Yes' : 'No' }}
        </span>
        <mat-slide-toggle formControlName="signalDetected" class="signal-slide-toggle">
        </mat-slide-toggle>
      </div>
    </div>

          <!-- Upload Instructions -->
      <ng-container *ngIf="uploadInstructions;">
        <label class="form-label">Upload Instructions</label>
        <div class="comment-list">{{ uploadInstructions }}</div>
      </ng-container>

<!-- Attachments -->
<div class="form-group">

 <label class="form-label">Attachments / Evidence</label>

<!-- Hidden File Input -->
<input
  type="file"
  multiple
  #fileInput
  formControlName="attachments"
  (change)="onFileSelected($event)"
  hidden
/>

<!-- Upload UI Box -->
<div class="upload-box" (click)="fileInput.click()">
  <i class="fas fa-cloud-upload-alt upload-icon"></i>
  <p class="upload-text">Click to upload or drag & drop files here</p>
</div>

<!--  Error Shown Below -->
<div class="mat-error-custom"
     *ngIf="assessmentForm.get('attachments')?.invalid 
            && assessmentForm.get('attachments')?.touched">
  Attachment is required
</div>
  <!-- Attached File Chips -->
  <div *ngIf="attachedFiles.length > 0" class="file-list">
    <mat-chip-listbox>
      <mat-chip-option *ngFor="let file of attachedFiles" removable (removed)="removeFile(file)">
        <i class="fas fa-paperclip"></i> {{ file.name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </div>

</div>



    <!-- Delay Reason -->
    <div class="form-group">
      <label class="form-label">Reason for Delay</label>
      <mat-form-field appearance="outline" class="full-width no-label">
        <textarea
          matInput
          placeholder="Provide reason if review was delayed..."
          rows="3"
          formControlName="delayReason"
        ></textarea>
          <mat-error *ngIf="assessmentForm.get('delayReason')?.touched && assessmentForm.get('delayReason')?.hasError('required')">
          Delay Reason is required as Activity is Overdue 
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
      <!-- <button mat-stroked-button type="button" (click)="goBack()">Back</button> -->
        <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="goBack()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
      <!-- <button mat-raised-button [style.background-color]="backgroundColorButton" type="submit">
        Complete
      </button> -->
       
          		<app-common-button
 
          label="Complete"
 
          title="Complete "
 
        
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onSubmit($event)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>


    </div>
  </form>
</div>

<!-- =======================
     SUBMISSION VIEW
======================= -->
<div *ngIf="isSubmiited" class="submission-container">

  <!-- Loading -->
  <div class="loading-header" *ngIf="!uploadCompleted && !uploadError">
    <h2>Completing your review activity<span class="dot-anim">...</span></h2>
    <p class="sub-text">Please wait while we submit your assessment and attachments.</p>
  </div>

  <!-- Success Message -->
  <div class="submission-success" *ngIf="uploadCompleted && uploadSuccess">
    <i class="fas fa-check-circle"></i>
    <h3>Activity Completed Successfully</h3>
  </div>

  <!-- Error -->
  <div *ngIf="uploadError" class="submission-error">
    <i class="fas fa-times-circle"></i>
    <h3>Activity Submission Failed</h3>
    <div class="error-summary">
      <button class="show-more-btn" (click)="toggleErrorDetails()">
        {{ showErrorDetails ? 'Hide details' : 'Show more' }}
      </button>
    </div>
    <div *ngIf="showErrorDetails" class="error-details">
      <pre>{{ detailedErrorMessage }}</pre>
    </div>
  </div>

  <!-- File upload status -->
  <div class="file-upload-list">
    <div class="file-item" *ngFor="let file of attachedFiles">
      <div class="spinner" *ngIf="!uploadCompleted && !uploadSuccess && !uploadError"></div>
      <i *ngIf="uploadCompleted && uploadSuccess" class="fas fa-check success-icon"></i>
      <i *ngIf="uploadCompleted && uploadError" class="fas fa-times error-icon"></i>
      <span class="file-name">{{ file.name }}</span>
    </div>
  </div>

  <!-- Final Action -->
  <div class="bottom-btn" *ngIf="uploadSuccess || uploadError">
    <!-- <button mat-raised-button [style.background-color]="backgroundColorButton" (click)="onAssesementDone()">
      Done
    </button> -->
    		     <app-common-button
 
          label="Done"
 
          title="Done "
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onAssesementDone()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
  </div>
</div>
